import React, { useEffect, useState } from "react";
import { clientApi } from "../lib/api";
import { MessageCircle, ExternalLink, Star } from "lucide-react";

export default function Talkie() {
  const [surveys, setSurveys] = useState([]);

  useEffect(() => {
    clientApi.get("/talkie").then(({ data }) => setSurveys(data)).catch(() => setSurveys([]));
  }, []);

  return (
    <div className="space-y-6" data-testid="cliente-talkie-page">
      <div>
        <div className="text-xs uppercase tracking-widest text-accent-orange mb-1">Pesquisas</div>
        <h1 className="font-display text-3xl md:text-4xl">Talkie · Pesquisas de Mercado</h1>
        <p className="text-sm text-neutral-400 mt-2">Insights capturados diretamente do consumidor final via pesquisas Talkie.</p>
      </div>

      <div className="grid md:grid-cols-2 gap-4">
        {surveys.map((s) => (
          <div key={s.id} className="border border-white/10 rounded-xl p-5 bg-white/[0.02]">
            <div className="flex justify-between items-start mb-3">
              <MessageCircle className="w-5 h-5 text-accent-orange" />
              {s.url && <a href={s.url} target="_blank" rel="noopener noreferrer" className="text-xs text-accent-orange hover:underline"><ExternalLink className="w-3 h-3 inline mr-1" /> Ver relatório</a>}
            </div>
            <div className="font-display text-xl leading-tight">{s.title}</div>
            {s.summary && <p className="text-sm text-neutral-300 mt-2">{s.summary}</p>}
            {s.respondents && <div className="text-[11px] text-neutral-500 mt-3"><b className="text-accent-yellow">{s.respondents}</b> respondentes</div>}
            {s.date && <div className="text-[11px] text-neutral-500 mt-1">{new Date(s.date).toLocaleDateString("pt-BR")}</div>}
          </div>
        ))}
        {surveys.length === 0 && (
          <div className="col-span-full text-sm text-neutral-500 border border-dashed border-white/10 rounded-xl p-10 text-center">
            Nenhuma pesquisa Talkie cadastrada. O admin adiciona em <span className="text-accent-orange">/admin/client-talkie</span>.
          </div>
        )}
      </div>
    </div>
  );
}
